import { render, staticRenderFns } from "./TermsGuidance.vue?vue&type=template&id=5bd74f58&scoped=true&"
import script from "./TermsGuidance.vue?vue&type=script&lang=js&"
export * from "./TermsGuidance.vue?vue&type=script&lang=js&"
import style0 from "./TermsGuidance.vue?vue&type=style&index=0&id=5bd74f58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd74f58",
  null
  
)

export default component.exports